import React, { useEffect, Children } from "react";
import "./InfiniteScroller.css";

const InfiniteScroller = ({ direction = "left", speed = "fast", children }) => {
  useEffect(() => {
    const scroller = document.querySelector(
      `.scroller[data-direction="${direction}"]`
    );

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation(scroller);
    }
  }, [direction]);

  const addAnimation = (scroller) => {
    if (scroller) {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".scroller__inner");

      // Duplicate each child element for scrolling effect
      const scrollerContent = Array.from(scrollerInner.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    }
  };

  return (
    <div className={`scroller`} data-direction={direction} data-speed={speed}>
      <div className="scroller__inner gap-[6px] md:gap-[10px]">{children}</div>
    </div>
  );
};

export default InfiniteScroller;
